import { computed, ref } from "vue";
import { defineStore } from "pinia";
import { IApp } from "@/types";
import { apiURL, makeAlert, sendRequest } from "@/utils";
import { URLs } from "@/constants";

export const useGlobalStore = defineStore("global", () => {
  const contentsStatus = ref<IApp.ILoadingStatus>(IApp.ILoadingStatus.Idle);
  const contents = ref<{
    privacyPolicy?: string;
    termsOfService?: string;
  }>({});

  const isContentsLoading = computed(() => contentsStatus.value === IApp.ILoadingStatus.Loading);

  const fetchContents = async () => {
    contentsStatus.value = IApp.ILoadingStatus.Loading;
    const response = await sendRequest<{
      privacyPolicy: string;
      termsOfService: string;
    }>({
      url: apiURL(URLs.API_GLOBAL_CONTENT_GET),
      method: "GET"
    });
    if (response.status) {
      contents.value = response.data;
      contentsStatus.value = IApp.ILoadingStatus.Success;
    } else {
      makeAlert(response.message, "error");
      contentsStatus.value = IApp.ILoadingStatus.Error;
    }
  };

  const upsertContents = async (content: Partial<IApp.Content>) => {
    contentsStatus.value = IApp.ILoadingStatus.Loading;
    const response = await sendRequest<{}>({
      url: apiURL(URLs.API_GLOBAL_CONTENT_GET),
      method: "PUT",
      data: content
    });
    if (response.status) {
      makeAlert("Content updated successfully", "success");
      contents.value = {
        ...contents.value,
        ...content
      };
      contentsStatus.value = IApp.ILoadingStatus.Success;
    } else {
      makeAlert(response.message, "error");
      contentsStatus.value = IApp.ILoadingStatus.Error;
    }
  };

  return {
    contents,
    contentsStatus,
    isContentsLoading,
    fetchContents,
    upsertContents
  };
});
